module.exports = __webpack_public_path__ + "img/default.009be159.png";